export default __webpack_public_path__ + "static/media/TV_Icon.18aae99b.png";